import { render, staticRenderFns } from "./SingleOpeningDefense.vue?vue&type=template&id=1bf0e81a&scoped=true&"
import script from "./SingleOpeningDefense.vue?vue&type=script&lang=js&"
export * from "./SingleOpeningDefense.vue?vue&type=script&lang=js&"
import style0 from "./SingleOpeningDefense.vue?vue&type=style&index=0&id=1bf0e81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf0e81a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCol,VIcon})
